<template lang="pug">
.wrapper.pt-header65
  header.gheader.-white.gheader-fix
    .gheader__link-back
      a(@click="backHome", href="javascript:void(0)") 戻る
  .container.stepup-uncheck.bg04
    .row.inner
      .user-post-detail__body__others.bg05
        div(v-if="serviceNoAnswers", v-for="(serviceAnswer,index) in serviceNoAnswers")
          .user-outline
            .user-outline__img(v-if="serviceAnswer['profile_image_path']")
              img(v-bind:src="serviceAnswer['profile_image_path'] + '?token=' + authToken + '&timestamp=' + timeStamp")
            .user-outline__img(v-else)
              img(src='./images/img_profile.png', alt='')
            .user-outline__body
              p.user-outline__body__role.fz11 {{serviceAnswer['shop_name']}} {{serviceAnswer['user_type_name']}}
              h3.user-outline__body__name.fz16 {{serviceAnswer['user_name']}}
</template>
<script>
export default {
  name: 'service-answer-call-list',
  created () {
    this.search()
  },
  data () {
    return {
      serviceNoAnswers: [],
      selectedServiceQuestionAnswerId: undefined
    }
  },
  computed: {
    authToken () {
      return window.localStorage.getItem('access_token')
    },
    timeStamp () {
      var d = new Date()
      var year = d.getFullYear()
      var month = d.getMonth() + 1
      var day = d.getDate()
      var hour = (d.getHours() < 10) ? '0' + d.getHours() : d.getHours()
      var min = (d.getMinutes() < 10) ? '0' + d.getMinutes() : d.getMinutes()
      var sec = (d.getSeconds() < 10) ? '0' + d.getSeconds() : d.getSeconds()
      return year + '' + month + '' + day + '' + hour + '' + min + '' + sec
    }
  },
  methods: {
    async search () {
      let res = await this.$store.dispatch('SERVICE_ANSWER_NOANSWER_LIST')
      .catch(err => {
        console.log(err)
        return
      })
      this.serviceNoAnswers = res
    },
    backHome: function () {
      this.$router.push({ path: '/' })
    }
  }
}
</script>


// WEBPACK FOOTER //
// ServiceAnswerCallList.vue?2ac4107f